export default __webpack_public_path__ + "static/flatter-dd9b651447637fb2eefcb5e8786f8a69.png";